import * as Actions from './constants';
import TryCountStorage from '../services/TryCountStorage';
/**
 * Try count middleware for it's local storage.
 * @return {any} Returns next action handle
 */

export default function storeMiddleware() {
  return function () {
    return function (next) {
      return function (action) {
        switch (action.type) {
          case Actions.SET_INITIAL_STATE:
            TryCountStorage.checkCache();
            break;
          case Actions.CHECK_RECOVERY_CODE_VALIDITY_FETCH:
          case Actions.SAVE_PASSWORD_FETCH:
          case Actions.RECOVER_BY_EMAIL_FETCH:
          case Actions.RECOVER_BY_PHONE_FETCH:
            TryCountStorage.increaseTryCount();
            break;
          case Actions.CHECK_RECOVERY_CODE_VALIDITY_SUCCESS:
          case Actions.SAVE_PASSWORD_SUCCESS:
          case Actions.RECOVER_BY_EMAIL_SUCCESS:
          case Actions.RECOVER_BY_PHONE_SUCCESS:
            TryCountStorage.resetTryCount();
        }
        return next(action);
      };
    };
  };
}